import { useApiMaterialsV1MaterialProductsUpdate } from 'api';
import { UseFormReturn } from 'form';
import { useNavigate } from 'react-router-dom';

import { UpdateFormValues } from '../../pages/MaterialProductDetails/MaterialProductDetails';
import { MaterialProductFormValues } from '../../pages/schema';
import { handleError } from '../../utils/handleFormError/handleFormError';

export const useUpdateMaterialProduct = (form: UseFormReturn<MaterialProductFormValues, unknown, UpdateFormValues>) => {
  const { setError } = form;
  const navigate = useNavigate();
  return useApiMaterialsV1MaterialProductsUpdate({
    mutation: {
      onError(error) {
        handleError(error, setError);
      },
      async onSuccess(_) {
        navigate(`/ground-control/material-products/`);
      },
    },
  });
};
